import * as API from "@api";

export const LANGUAGES = () => API.Languages.getAll({ limit: 1000 });
